


import {AuthRequestVM} from './AuthRequestVM';
export class ChangePasswordRequestVM extends AuthRequestVM {
    
    newPassword?: string;
    
    confirmPassword?: string;
    
}
